module.exports = __webpack_public_path__ + "media/images/bg-37612c4e99a628361fa1740eb3a71dbe.png";